/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Noproductdatadescription3Inputs */

const id_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data produk untuk sandbox ini.`)
};

const ms_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data produk wujud untuk sandbox ini.`)
};

const da_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen produktdata findes for denne sandbox.`)
};

const de_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diese Sandbox existieren keine Produktdaten.`)
};

const en_us2_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No product data exists for this sandbox.`)
};

const es_es2_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No existen datos de producto para este sandbox.`)
};

const es_mx2_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No existen datos de producto para este sandbox.`)
};

const fil_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang data ng produkto para sa sandbox na ito.`)
};

const fr_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée produit n'existe pour ce sandbox.`)
};

const it_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato di prodotto esiste per questo sandbox.`)
};

const hu_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem létezik termékadat ehhez a sandbox-hoz.`)
};

const nl_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er bestaan geen productgegevens voor deze sandbox.`)
};

const no_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen produktdata finnes for denne sandboxen.`)
};

const pl_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych produktu dla tego sandboxa.`)
};

const pt_br2_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não existem dados de produto para este sandbox.`)
};

const pt_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não existem dados de produto para esta sandbox.`)
};

const ro_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu există date de produs pentru acest sandbox.`)
};

const fi_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tälle hiekkalaatikolle ei ole tuotetietoja.`)
};

const sv_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen produktdata finns för denna sandlåda.`)
};

const vi_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu sản phẩm cho sandbox này.`)
};

const tr_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sandbox için ürün verisi bulunmuyor.`)
};

const cs_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tento sandbox neexistují žádná data produktu.`)
};

const bg_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма данни за продукт за този sandbox.`)
};

const ru_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этой песочницы нет данных о продукте.`)
};

const uk_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для цього Sandbox немає даних продукту.`)
};

const ar_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات منتج لـ Sandbox هذا.`)
};

const hi_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सैंडबॉक्स के लिए कोई उत्पाद डेटा मौजूद नहीं है।`)
};

const th_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูลผลิตภัณฑ์สำหรับแซนด์บ็อกซ์นี้`)
};

const ja_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサンドボックスの製品データは存在しません。`)
};

const zh_cn2_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此沙盒不存在产品数据。`)
};

const zh_hant1_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此沙盒不存在產品資料。`)
};

const ko_sandboxes_noproductdatadescription3 = /** @type {(inputs: Sandboxes_Noproductdatadescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Sandbox에 대한 제품 데이터가 없습니다.`)
};

/**
* | output |
* | --- |
* | "No product data exists for this sandbox." |
*
* @param {Sandboxes_Noproductdatadescription3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_noproductdatadescription3 = /** @type {((inputs?: Sandboxes_Noproductdatadescription3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Noproductdatadescription3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_noproductdatadescription3(inputs)
	if (locale === "ms") return ms_sandboxes_noproductdatadescription3(inputs)
	if (locale === "da") return da_sandboxes_noproductdatadescription3(inputs)
	if (locale === "de") return de_sandboxes_noproductdatadescription3(inputs)
	if (locale === "en-US") return en_us2_sandboxes_noproductdatadescription3(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_noproductdatadescription3(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_noproductdatadescription3(inputs)
	if (locale === "fil") return fil_sandboxes_noproductdatadescription3(inputs)
	if (locale === "fr") return fr_sandboxes_noproductdatadescription3(inputs)
	if (locale === "it") return it_sandboxes_noproductdatadescription3(inputs)
	if (locale === "hu") return hu_sandboxes_noproductdatadescription3(inputs)
	if (locale === "nl") return nl_sandboxes_noproductdatadescription3(inputs)
	if (locale === "no") return no_sandboxes_noproductdatadescription3(inputs)
	if (locale === "pl") return pl_sandboxes_noproductdatadescription3(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_noproductdatadescription3(inputs)
	if (locale === "pt") return pt_sandboxes_noproductdatadescription3(inputs)
	if (locale === "ro") return ro_sandboxes_noproductdatadescription3(inputs)
	if (locale === "fi") return fi_sandboxes_noproductdatadescription3(inputs)
	if (locale === "sv") return sv_sandboxes_noproductdatadescription3(inputs)
	if (locale === "vi") return vi_sandboxes_noproductdatadescription3(inputs)
	if (locale === "tr") return tr_sandboxes_noproductdatadescription3(inputs)
	if (locale === "cs") return cs_sandboxes_noproductdatadescription3(inputs)
	if (locale === "bg") return bg_sandboxes_noproductdatadescription3(inputs)
	if (locale === "ru") return ru_sandboxes_noproductdatadescription3(inputs)
	if (locale === "uk") return uk_sandboxes_noproductdatadescription3(inputs)
	if (locale === "ar") return ar_sandboxes_noproductdatadescription3(inputs)
	if (locale === "hi") return hi_sandboxes_noproductdatadescription3(inputs)
	if (locale === "th") return th_sandboxes_noproductdatadescription3(inputs)
	if (locale === "ja") return ja_sandboxes_noproductdatadescription3(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_noproductdatadescription3(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_noproductdatadescription3(inputs)
	return ko_sandboxes_noproductdatadescription3(inputs)
});
export { sandboxes_noproductdatadescription3 as "sandboxes.noProductDataDescription" }